var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._g(_vm._b({attrs:{"color":_vm.color}},'v-avatar',_vm.$attrs,false),_vm.$listeners),[(_vm.user.profile_picture)?_c('v-img',{attrs:{"src":_vm.user.profile_picture}}):_c('div',{staticClass:"font-weight-bold",style:(_vm.initials.length > 1 ? 'font-size: 60%' : 'font-size: 80%')},[_vm._v(" "+_vm._s(_vm.initials)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }